module.exports = __webpack_public_path__ + "static/media/logo-caracas.c48e1747.png";